import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import header from '@/components/Header'
Vue.component("header-app", header);
import audioPlayer from '@/components/audio-player'
Vue.component("audio-player", audioPlayer);
import presentacionModulo from '@/components/presentacion-modulo'
Vue.component("presentacion-modulo-app",presentacionModulo)
import navButtons from '@/components/nav-buttons'
Vue.component("nav-buttons-app",navButtons)
import navMenu from '@/components/nav-menu'
Vue.component("nav-menu-app",navMenu)
import dialogos from '@/components/dialogos'
Vue.component("dialogos-app",dialogos)
import botonCerrarModal from '@/components/boton-cerrar-modal'
Vue.component("boton-cerrar-modal-app", botonCerrarModal);
import modal from '@/components/modal'
Vue.component("modal-app",modal)
import actividadUnicaResp from '@/components/actividad-unica-resp'
Vue.component("actividad-unica-resp-app", actividadUnicaResp);

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({behavior: "smooth"})
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({behavior: "smooth"})
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
